module.exports = __webpack_public_path__ + "assets/img/768_main_img_carousel_3.5a1893fc.png";